import React from "react";
import { connect } from "react-redux";

import { fetchLifeSettlementChoices, fetchManagerAgents, fetchAccountsListChoices } from "actions";
import AdminPageHeader from "./AdminPageHeader";
import CaseSubmissionReport from "./reports/CaseSubmissionReport";
import LeadsReport from "./reports/LeadsReport";
import OutboundEmailsReport from "./reports/OutboundEmailsReport";
import OutgoingCallsReport from "./reports/OutgoingCallsReport";

const AdminReportsPage = props => {
  React.useEffect(() => {
    props.fetchLifeSettlementChoices();
    props.fetchManagerAgents();
    props.fetchAccountsListChoices();
    document.title = "LifeRoc | Admin Reports";
  }, []);

  return (
    <>
      <AdminPageHeader />
      <div style={{ marginTop: "1.5rem" }}>
        <CaseSubmissionReport />
        <LeadsReport />
        <OutboundEmailsReport />
        <OutgoingCallsReport />
      </div>
    </>
  );
};

export default connect(null, {
  fetchLifeSettlementChoices,
  fetchManagerAgents,
  fetchAccountsListChoices,
})(AdminReportsPage);
